import React, {useContext} from 'react';
import MenuMatchItem from './MenuMatchItem';
import LiveContext from '../../../contexts/LiveContext';
import { getMatchStreamingProps } from '../../../data/streaming/streamingUtils';
import { classIf } from '../../../data/utils';

function MenuCompetitionItemLive(props) {
    const matchesList = props.events.map(function(match) {
        const streamingMap = getMatchStreamingProps(match);
        return <MenuMatchItem key={match.id} {...match} matchData={match} streaming={streamingMap && streamingMap[match.id]} />
    });

    const liveContext = useContext(LiveContext);
    const selected = liveContext.currentMatch && liveContext.currentMatch.tournamentRef === props.id;

    return (
        <div className="contenitore-evento-widget bg-grigio-chiaro bordo-tondo">
            <div className={"elemento-competizioni-widget singola-competizione bg-bianco pointer nero margine-giu-mezzo live-si" + classIf(selected, 'competizione-attiva') }>
                <span className="ml-2">{props.descrizione}</span>
                <span className='events__count-wrapper'>{props.eventsCount}</span>
            </div>
            {matchesList}
        </div>
    );
}
    
export default MenuCompetitionItemLive;